document.addEventListener('DOMContentLoaded',function(){
  var metals={yellow:['#E8C989','#C9A96A','#8C713D'],white:['#EDEFF2','#C2C8CE','#848B94'],rose:['#F0C6AC','#D49B78','#9C6547']};
  var stops=['g1','g2','g3'].map(function(id){return document.getElementById(id)});
  document.querySelectorAll('.metal-switch button').forEach(function(btn){
    btn.addEventListener('click',function(){
      var m=btn.dataset.set;
      document.documentElement.setAttribute('data-metal',m);
      if(stops[0]){metals[m].forEach(function(c,i){stops[i].setAttribute('stop-color',c)})}
      document.querySelectorAll('.metal-switch button').forEach(function(b){b.setAttribute('aria-pressed',b===btn?'true':'false')});
    });
  });
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
});
